<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <ul
      data-v-3738b722=""
      class="c-sidebar-nav ps mt-3 user__collapsed"
      style="position: relative"
    >
      <li
        class="c-sidebar-nav-dropdown"
        data-v-3738b722=""
        v-on:click="handleUser"
      >
        <a class="c-sidebar-nav-dropdown-toggle">
          <div class="profile__image">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4lQHH4lXf8gt-fEpRHuQPB4N8l5VgYHYezg&usqp=CAU"
              alt=""
            />
          </div>
          Mi cuenta
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link to="/account" class="c-sidebar-nav-link">
              Mis datos
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <a class="c-sidebar-nav-link" target="_self" @click="logOut">
              Cerrar sesión
            </a>
          </li>
        </ul>
      </li>
    </ul>

    <CRenderFunction flat :content-to-render="navigation" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import routes from "./_nav";
import { mapActions } from 'vuex'

export default {
  data: function () {
    return {
      navigation: [],
    };
  },
  name: "TheSidebar",
  methods: {
    ...mapActions(['logOut']),
    handleUser(e) {
      const parent = e.target.parentElement;
      if (parent.classList.contains("c-show")) {
        parent.classList.remove("c-show");
        parent.parentElement.classList.remove("user__uncollapsed");
      } else {
        parent.classList.add("c-show");
        parent.parentElement.classList.add("user__uncollapsed");
      }
    },

    
    async getRoutesAPI() {
      this.$store.state.token = localStorage.getItem("token");

      const payloadMenu = {
        metodo: "GETMENU",
        data: `idUser=${localStorage.getItem("profileId")}`,
      };

      try {
        const prom = await this.$store.dispatch("metodoPost", payloadMenu);
        if (prom) {
          const routes = this.$store.getters.getRespuestaREST;
          console.log(routes);
          Object.values(routes._children).forEach((item) => {
            if (item.route == "") delete item.route;
          });
          this.navigation = [routes];
          this.$store.state.sidebarApps = this.navigation[0]._children;

          if (this.$store.state.sidebarApps.length == 0) {
            this.logOut("No tienes aplicaciónes asignadas");
          }

          this.$store.state.Loading = false;
          return;
        }
      } catch (error) {
        this.logOut("Tu token ha expirado");
      }
    },
    async logOut(message) {
      this.$store.state.Loading = false;
      const res = await this.$swal.fire({
        title: message,
        icon: "warning",
        allowOutsideClick: false,
      });

      if (res.isConfirmed) {
        localStorage.removeItem("token");
        this.$router.push("/pages/login");
      }
    },
  },

  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    
  },
  mounted() {
    this.getRoutesAPI();
    this.navigation = routes;
  },
};
</script>
